import React, { Component } from 'react';
import { Row, Col, Button, Translate, Modal, FormField, Input, Spinner } from '$common';
import CSSModules from 'react-css-modules';
import style from './onboarding.scss';
import { browserHistory } from 'react-router';
import Cookies from 'js-cookie';

@CSSModules(style, { allowMultiple: true })
export default class Onboarding extends Component {

  state = {
    modalIsOpen: false,
    requestType: '',
    brief: '',
    isFetching: true
  };

  componentWillMount() {
    // window.Intercom('trackEvent', 'OPENED_PROJECT_CREATION');
    setTimeout(() => {
      this.setState({ isFetching: false })
    }, 1300);
  }

  createRequest(requestType) {
    // window.Intercom('trackEvent', 'OPENED_BRIEF_REQUEST')
    this.setState({ modalIsOpen: true, requestType: requestType });
  }

  submitRequest() {
    const agent = JSON.parse(Cookies.get('agent'));
    // window.Intercom('trackEvent', 'SENT_PROJECT_REQUEST');
    this.setState({ brief: this.refs.brief_1.refs.element.value, modalIsOpen: false });
    this.props.onSendSlackMessage(
    ` *${this.state.requestType}* :bow_and_arrow:
    ${agent.email}
    *${Translate.get('brief_of_research')}* : ${this.refs.brief_1.refs.element.value}
    *${Translate.get('targeting_for_research')}* : ${this.refs.brief_2.refs.element.value}
    *${Translate.get('number_of_research_participants')}* : ${this.refs.brief_3.refs.element.value}`, 
    ':email:'
    );
  }

  renderActions(type) {
    return (
      <div styleName="actions">
        <Button styleName="button" type="white-ghost" size="small" onClick={ () => {
          browserHistory.push('/project/create');
          // window.Intercom('trackEvent', 'SELECTED_CATEGORY', { category: type });
        }}>{Translate.get('do_it_yourself')}</Button> <br />
        <Button styleName={'button text'} size="small" onClick={ () => this.createRequest(Translate.get(type)) }>{Translate.get('make_a_request')}</Button>
      </div>
    )
  }

  render() {
    const { isFetching, modalIsOpen } = this.state;
    
    return !isFetching ? (
      <div styleName="root">
        <Row justify="center">
          <Col md="4/5">
            <div styleName="page-title">{Translate.get('what_do_you_need')}</div>
            <Row>
              <Col md="1/3">
                <div styleName="service-item" style={{ backgroundImage: `url(${require('$shared/images/services/custom_survey.jpg')})` }}>
                  <span styleName="service-title">{Translate.get('custom_survey')}</span>
                  {this.renderActions('custom_survey')}
                </div>
              </Col>
              <Col md="1/3">
                <div styleName="service-item" style={{ backgroundImage: `url(${require('$shared/images/services/concept_testing.jpg')})` }}>
                  <span styleName="service-title">{Translate.get('concept_testing')}</span>
                  {this.renderActions('concept_testing')}
                </div>
              </Col>
              <Col md="1/3">
                <div styleName="service-item" style={{ backgroundImage: `url(${require('$shared/images/services/product_testing.jpg')})` }}>
                  <span styleName="service-title">{Translate.get('product_testing')}</span>
                  {this.renderActions('product_testing')}
                </div>
              </Col>
              <Col md="1/3">
                <div styleName="service-item" style={{ backgroundImage: `url(${require('$shared/images/services/household_penetration.jpg')})` }}>
                  <span styleName="service-title">{Translate.get('household_penetration')}</span>
                  {this.renderActions('household_penetration')}
                </div>
              </Col>
              <Col md="1/3">
                <div styleName="service-item" style={{ backgroundImage: `url(${require('$shared/images/services/usage_and_attitude.jpg')})` }}>
                  <span styleName="service-title">{Translate.get('usage_and_attitude')}</span>
                  {this.renderActions('usage_and_attitude')}
                </div>
              </Col>
              <Col md="1/3">
                <div styleName="service-item" style={{ backgroundImage: `url(${require('$shared/images/services/consumer_pulse.jpg')})` }}>
                  <span styleName="service-title">{Translate.get('consumer_pulse')}</span>
                  {this.renderActions('consumer_pulse')}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal
          isOpen={modalIsOpen}
          title={Translate.get('brief')}
          onCloseRequest={() => this.setState({ modalIsOpen: false })}
        >
          <FormField label={Translate.get('brief_of_research')}>          
            <Input
              rows={3}
              ref="brief_1"
              name="brief_1"
            />
          </FormField>
          <FormField label={Translate.get('targeting_for_research')}>
            <Input
              rows={3}
              ref="brief_2"
              name="brief_2"
            />
          </FormField>
          <FormField label={Translate.get('number_of_research_participants')}>
            <Input
              type="number"
              ref="brief_3"
              name="brief_3"
            />
          </FormField>
          <Button type="success" block onClick={ () => this.submitRequest() }>{Translate.get('submit')}</Button>
        </Modal>
      </div>
    ) : (
      <Spinner block center />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/onboarding/onboarding.js